import './errorHandler';
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.scss';

import App from './app/App';
import reportWebVitals from './reportWebVitals';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('../firebase-messaging-sw.js')
    .then(registration => {
      // eslint-disable-next-line no-console
      console.log('Service worker registered:', registration.scope);
    })
    // eslint-disable-next-line no-console
    .catch(err => console.error('SW registration failed:', err));
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
